'use client';

import { useQuery } from '@tanstack/react-query';
import { subdomainAtom } from 'app/blog/[domain]/_components/blog-state';
import { PostCard } from 'app/blog/[domain]/(standalone)/(home)/post-card';
import { useAtomValue } from 'jotai';
import { api } from 'orpc/react';
import { Skeleton } from 'ui';

export function PromotedPosts() {
  const subdomain = useAtomValue(subdomainAtom);
  const { data } = useQuery(
    api.blog.promotedPosts.queryOptions({
      input: {
        subdomain,
      },
    }),
  );
  const { posts } = data || {};
  const hasData = posts && posts.length > 0;
  return (
    <section className="not-found-posts">
      <p className="not-found-posts-kicker">Latest</p>
      <h2 className="not-found-posts-title">More from the blog</h2>
      <ul className="not-found-post-list">
        {hasData
          ? posts.map((p) => (
              <li className="not-found-post-item" key={p.id}>
                <PostCard post={p} />
              </li>
            ))
          : Array(6)
              .fill(null)
              .map((_, i) => (
                <li key={i} className="not-found-post-placeholder">
                  <Skeleton className="not-found-post-placeholder-media" />
                  <Skeleton className="not-found-post-placeholder-title" />
                  <Skeleton className="not-found-post-placeholder-copy" />
                  <Skeleton className="not-found-post-placeholder-meta" />
                </li>
              ))}
      </ul>
    </section>
  );
}
